const { isEmpty } = require("lodash");

const filterEmptyObjects = (values) =>
  Object.entries(values).reduce((res, [key, value]) => {
    if (typeof value === "object") {
      if (!isEmpty(value) && Object.keys(value).length > 1) {
        const filteredObj = filterEmptyObjects(value);
        if (!isEmpty(filteredObj)) {
          return { ...res, [key]: filteredObj };
        }
      }
      return res;
    }
    return { ...res, [key]: value };
  }, {});

export default filterEmptyObjects;
